/**
 * `1536` → `1.5 KB`. THE attachment-row size label. Moved here 2026-09-15 (R13)
 * out of `components/OrderAttachments.js`, which re-exports it unchanged, so
 * `components/PendingUploadRow.js` could use it without importing the component
 * that renders it.
 */
export function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

export default formatFileSize;
